<div class="row">
	<div class="col-sm-12">
		<app-objective-list-filters
			#listfilters
			[searchparams]="advancedSearch"
			[projectid]="projectid">
		</app-objective-list-filters>
	</div>
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				routerLink="/project/{{this.projectid}}/objective/new"
				*ngIf="project?.isDraft && !usercompanyid">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>
			<a
				href="javascript:void(0)"
				(click)="datatable.rowDetail.expandAllRows()">
				Espandi tutte
				<i class="fas fa-expand mr-3"></i>
			</a>

			<a
				href="javascript:void(0)"
				(click)="datatable.rowDetail.collapseAllRows()">
				Chiudi tutte
				<i class="fas fa-compress"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap expandable"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					[rowClass]="rowClass"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					(activate)="onActivate($event)"
					[messages]="{
          emptyMessage: 'labels.empty-objectives' | translate,
          totalMessage: 'labels.total' | translate
		}">

					<!-- Row Detail Template -->
					<ngx-datatable-row-detail
						[rowHeight]="'auto'"
						#detailRow>
						<ng-template
							let-row="row"
							ngx-datatable-row-detail-template>
							<a
								*ngIf="project?.isDraft && !usercompanyid"
								class="float-right mt-1 btn btn-sm btn-primary"
								routerLink="/project/objective/{{row.id}}/activity/new">
								<i
									container="body"
									ngbTooltip="{{'labels.activity-create' | translate}}"
									class="feather icon-plus"></i>
							</a>
							<div *ngIf="!row.activities?.length">
								Non ci sono ancora attività su questo obiettivo
							</div>
							<div
								*ngIf="row.activities?.length"
								class="activities-table">
								<div class="title">
									<b>{{'labels.activities' | translate}}</b>
								</div>
								<ul>
									<li
										(dbclick)="onActivateActivity(a.id)"
										*ngFor="let a of row.activities; let i = index;">
										<div class="row">
											<div class="col-10">
												<span class="activity-name">
													<a
														routerLink="/project/objective/activity/view/{{a.id}}"
														class="link"
														ngbTooltip="{{'labels.details' | translate}}">
														{{ a.name }}
													</a>

												</span>
												dal {{a.startdate | date: 'dd/MM/yyyy' }}
										al {{a.stopdate | date: 'dd/MM/yyyy' }}
											</div>
											<div class="col-2">
												<span class="icon-buttons">

													<a
														routerLink="/project/objective/{{row.id}}/activity/edit/{{a.id}}"
														class="link"
														*ngIf="project?.isDraft && !usercompanyid">
														<i
															container="body"
															ngbTooltip="{{'labels.edit' | translate}}"
															class="feather icon-edit"></i>
													</a>
													<a
														(click)="deleteActivity(a, $event)"
														class="link"
														*ngIf="project?.isDraft && !usercompanyid">
														<i
															container="body"
															ngbTooltip="{{'labels.delete' | translate}}"
															class="feather icon-trash"></i>
													</a>

												</span>
											</div>
										</div>

									</li>
								</ul>
							</div>

						</ng-template>
					</ngx-datatable-row-detail>

					<ngx-datatable-column
						[flexGrow]="0.2"
						[resizeable]="false">
						<ng-template
							let-row="row"
							let-expanded="expanded"
							ngx-datatable-cell-template>
							<a
								href="javascript:void(0)"
								[class.datatable-icon-right]="!expanded"
								[class.datatable-icon-down]="expanded"
								title="Expand/Collapse Row"
								(click)="datatable.rowDetail.toggleExpandRow(row)">
							</a>
						</ng-template>
					</ngx-datatable-column>

					<!-- id -->
					<ngx-datatable-column
						prop="id"
						[flexGrow]="0.4"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>
					<!-- name -->
					<ngx-datatable-column
						prop="name"
						[flexGrow]="2"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a routerLink="/project/{{this.projectid}}/objective/edit/{{row.id}}">{{value}}</a>
						</ng-template>
					</ngx-datatable-column>
					<!-- startdate -->
					<ngx-datatable-column
						prop="startdate"
						[flexGrow]="1.5"
						[name]="'labels.startdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>
					<!-- stopdate -->
					<ngx-datatable-column
						prop="stopdate"
						[flexGrow]="1.5"
						[name]="'labels.stopdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>
					<!-- dayofwork -->
					<ngx-datatable-column
						prop="dayofwork"
						[flexGrow]="2"
						[name]="'labels.dayofwork' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<a
									routerLink="/project/{{this.projectid}}/objective/edit/{{row.id}}"
									class="link"
									*ngIf="project?.isDraft && !usercompanyid">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link"
									*ngIf="project?.isDraft && !usercompanyid">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
